module.exports = __webpack_public_path__ + "static/media/map2.8e07bbe9.png";